import type { RouteObject } from 'react-router'

import { PlanningPage } from '@/features/planning/PlanningPage'

export const routes: RouteObject[] = [{ path: 'planning', element: <PlanningPage /> }]
